const URL =
  process.env.NODE_ENV === 'production'
    ? 'https://cms.ednet.cn'
    : 'https://localhost:21021'

export default URL



// WEBPACK FOOTER //
// ./src/utiltools/url.js